<template>
  <v-row
      class="loading-overlay"
      align="center"
      justify="center"
  >
    <v-progress-circular size="48" indeterminate color="primary"></v-progress-circular>
  </v-row>

</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "OverlayLoading",
});
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
}
</style>